import { Link, usePage } from "@inertiajs/react";
import { ClipboardCheck } from "lucide-react";

import { Badge } from "@/components/ui/badge";
import {
  SidebarGroup,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";
import { globalApprovalsPath } from "@/routes";
import type { SharedData } from "@/types";

export function NavPersonal() {
  const page = usePage<SharedData>();
  const pendingCount = page.props.auth.pending_approvals_count ?? 0;

  return (
    <SidebarGroup className="px-2 py-0">
      <SidebarMenu>
        <SidebarMenuItem>
          <SidebarMenuButton
            asChild
            isActive={page.url.startsWith("/approvals")}
            tooltip={{ children: "Hub Central" }}
          >
            <Link href={globalApprovalsPath()} className="relative">
              <ClipboardCheck className="h-4 w-4" />
              <span>Hub Central</span>
              {pendingCount > 0 && (
                <Badge
                  variant="destructive"
                  className="ml-auto h-5 min-w-5 px-1.5 text-xs"
                >
                  {pendingCount > 99 ? "99+" : pendingCount}
                </Badge>
              )}
            </Link>
          </SidebarMenuButton>
        </SidebarMenuItem>
      </SidebarMenu>
    </SidebarGroup>
  );
}
